var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-row", [_c("h2", [_vm._v("opensalud ScoreCard")]), _c("br")]),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          content: _vm.$t("tests.health-data-colorwarning"),
          okFn: function async() {
            _vm.healthDataGraphColor.visible = false
          },
          cancelFn: function() {
            _vm.back()
          },
          dontShowAgainCookie: _vm.healthDataGraphColor.cookie,
          dontShowAgainCookieExpirationDays: 90
        },
        model: {
          value: _vm.healthDataGraphColor.visible,
          callback: function($$v) {
            _vm.$set(_vm.healthDataGraphColor, "visible", $$v)
          },
          expression: "healthDataGraphColor.visible"
        }
      }),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            {
              staticClass: "p-2",
              attrs: { cols: "12", sm: "12", md: "12", lg: "6" }
            },
            [
              _c(
                "b-card",
                { staticClass: "card-chart-container" },
                [
                  _c("h5", { staticClass: "text-center mb-2" }, [
                    _vm._v(
                      _vm._s(_vm.$t("tests.self-evaluation-tests.title")) +
                        " - " +
                        _vm._s(_vm.$t("tests.resultsDiagram"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("self-evaluation-test-diagram")
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "p-2",
              attrs: { cols: "12", sm: "12", md: "12", lg: "6" }
            },
            [
              _c(
                "b-card",
                { staticClass: "card-chart-container" },
                [
                  _c("h5", { staticClass: "text-center mb-2" }, [
                    _vm._v(_vm._s(_vm.$t("healthvariables")))
                  ]),
                  _vm._v(" "),
                  _c("health-data-diagram")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d7c1f66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d7c1f66","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/selfEvaluationTests/OpensaludScorecard.vue
// module id = 3878
// module chunks = 6